import React, { useState } from 'react';
import { ArrowUpRight, Mail } from 'lucide-react';
import Magnetic from './Magnetic';
import { portalApi } from '../../lib/portalApi';

export default function Dispatch() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) return;
    setError('');
    setLoading(true);
    try {
      await portalApi.submitContact({
        name: trimmed.split('@')[0] || 'Subscriber',
        email: trimmed,
        phone: '',
        role: 'Newsletter subscriber',
        interests: ['Pink City Dispatch'],
        enquiryType: 'Newsletter / Dispatch',
        message: 'Subscribed via homepage Pink City Dispatch form.',
      });
      setDone(true);
      setEmail('');
    } catch (err) {
      setError(err.message || 'Could not subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="dispatch" className="relative bg-[#08080a] pt-10 pb-0 lg:pt-20 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pb-8">
        <div className="reveal-up rounded-3xl border border-white/10 bg-gradient-to-br from-white/[0.04] to-transparent p-8 sm:p-10 lg:p-14 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="text-[#ff8ec5] text-xs font-semibold tracking-[0.25em] uppercase mb-4">
              The Pink City Dispatch
            </div>
            <h2 className="font-semibold tracking-tight text-white text-3xl sm:text-4xl md:text-5xl leading-[1.08]">
              A monthly perspective on venture building
            </h2>
            <p className="mt-5 text-white/55 text-base sm:text-lg leading-relaxed max-w-xl">
              Founder journeys, market shifts, emerging sectors and capital, insights from the
              ventures we build and the ecosystem around them.
            </p>
          </div>

          <div className="lg:col-span-5">
            {done ? (
              <div className="rounded-2xl border border-[#d42b92]/40 bg-[#d42b92]/15 px-5 py-6 text-white">
                <p className="font-medium">You&rsquo;re on the list.</p>
                <p className="text-sm text-white/70 mt-1">We&rsquo;ll send the next dispatch to your inbox.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
                <div className="flex-1 flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3">
                  <Mail className="w-4 h-4 text-white/40 shrink-0" />
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@venture.com"
                    className="w-full bg-transparent outline-none text-sm text-white placeholder:text-white/30"
                  />
                </div>
                <Magnetic>
                  <button
                    type="submit"
                    disabled={loading}
                    className="group inline-flex items-center justify-center gap-2 px-5 py-3 rounded-2xl bg-[#d42b92] text-white text-sm font-medium hover:bg-white hover:text-black transition-colors whitespace-nowrap disabled:opacity-60"
                  >
                    {loading ? 'Saving…' : 'Subscribe'}
                    <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
                  </button>
                </Magnetic>
              </form>
            )}
            {error ? <p className="mt-3 text-sm text-red-300">{error}</p> : null}
          </div>
        </div>
      </div>
      {/* <div className="hidden lg:flex flex-col items-center pb-8 pt-12 text-[11px] uppercase tracking-[0.25em] text-white/35 shrink-0">
        <span>Keep scrolling</span>
        <span className="mt-2 w-px h-8 bg-gradient-to-b from-[#d42b92] to-transparent" />
      </div> */}
    </section>
  );
}
